import AScene from "../../library/ExtendedObjects/AScene.js";
import TrayEntry from "./TrayEntry.js";
import MakeATools from "./MakeATools.js";
import gameData from "../../gameData.js";
import PlaceConstraintsAll from "./PlaceConstraintsAll.js";
import SetItemData from "../BackLog/SetItemData.js";
import TweensPlacer from "../TweensFolder/TweensPlacer.js";
import {SavePrintCake} from "./SavePrint.js";
import ABCyaPhaser from "@abcya/abcya_phaser";
import FontKeys from "../../FontKeys.js";

export default class PlaceItems extends AScene
{
    /********************************************************/
    /*        The scene after Pick a color, this scene      */
    /*       is the make a cake, tools are on the left,     */
    /*            and can decoate a cake on the right       */
    /*                                                      */
    /********************************************************/
    static get KEY() { return 'PlaceItems'; }
    
    create()
        {
            this.Shader;
            this.TabList = [];
            this.ConstraintObjects = {Cake: 0,Undo: 0,Sound: 0, Tray: 0,Done:0};
            this.TabBack;
            this.Active = 0;
            this.IsPaused = false;
            this.CakeMask;
            this.CandleArea;
            this.BackLog = [];
            this.Icing = 'null';
            this.Id = 0;
            this.MouseDown = false;
            this.CandleArea;
            this.CakeCenter;
            this.CakeBottom;
            this.RenderLog = [];
            this.DrawLog;
            this.LogDraw = false;
            this.DepthList = {
                BackGround:0,
                BalloonBack: 0,
                BalloonFront: 0,
                Table:0,
                Shader:0,
                Buttons: 0,//Plate
                Tray: 0,//Cake
                PaintTool: 0,//On tray toppings
                Icing: 0,
                Toppings: 0,
                Fire: 0,
                Tabs:0
            };

            var i = 0;
            for (let x in this.DepthList)
            {
                this.DepthList[x] = i;
                i++;
            }

            this.ClearGroup = this.add.group();
            this.CakeGroup = this.add.group();

            this.Animations = new TweensPlacer(this);

            this.PlaceAssets();

            this.SetItemData = new SetItemData(this);
            this.TrayEntry = new TrayEntry(this);
            this.Constraints = new PlaceConstraintsAll(this,this.ConstraintObjects);//
            this.PlaceTools = new MakeATools(this,this.Constraints.PlaceCheck);//passes in the pointerupfunction

            this.CreateMask();

            this.CakeGroup.add(this.CakeMask.geometryMask);

            this.ClearGroup = (this.TrayEntry.PaintEntry());
            this.ClearGroup.setDepth(this.DepthList.PaintTool);
            this.ClearGroup.getChildren().forEach((child)=>{
                this.addTween(child,800,{x: {start: child.x - this.TabBack.width, to: child.x}},Phaser.Math.Easing.Quadratic.InOut);
            })
            
            this.TrayEntry.SlideIncrement = 246;
            //console.log(this.TrayEntry.PaintEntry());

            this.CreateRenderLayer();

            this.PaintTint = 0x424242;
            this.Circle = this.add.circle(-100,-100,17,this.PaintTint);
            this.Circle.fillColor = (this.PaintTint);

            this.PrevNumber = 20;
            this.PressedDrawButton;
            this.PressedSizeButton;

            //this.DragRules();
            var OldPlacement = {};
            var Fire;

            this.input.on('dragstart', (pointer,GameObject)=>
            {
                if (this.Active.getData('TabName') != "PaintTray")
                {
                    OldPlacement.x = GameObject.x;
                    OldPlacement.y = GameObject.y;
                    if (GameObject.getData('TabName') === "CandleTray")
                    {
                        Fire = GameObject.getData('Fire');
                        Fire.setVisible(false);
                    }
                    else if (GameObject.getData('TabName') === "PatternTray")
                    {
                        GameObject.clearMask();
                    }
                    //OriginAdjustmentX = item.x - pointer.x;
                    //OriginAdjustmentY = item.y - pointer.y;
                }
            });

            this.input.on('drag',(pointer, GameObject, Dx, Dy)=>
            {
                if (this.Active.getData('TabName') != "PaintTray")
                {
                    GameObject.x = Dx;
                    GameObject.y = Dy;
                }
            });

            this.input.on('dragend',(pointer, GameObject)=>
            {
                if (this.Active.getData('TabName') != "PaintTray")
                {
                    if (GameObject.x != OldPlacement.x || GameObject.y != OldPlacement.y)
                    {
                        GameObject.setData('OldPlacement',OldPlacement);
                        this.Constraints.PlaceCheck(GameObject,{Active: GameObject},"Move");
                    }

                    this.SetItemData.FireCheck(GameObject,"Drag");
                }
            });

            this.input.on('pointerdown',(pointer)=>
            {
                if (this.CandleArea.contains(pointer.x, pointer.y) || this.CakeCenter.contains(pointer.x, pointer.y) || this.CakeBottom.contains(pointer.x, pointer.y))
                {
                    if (this.Active.getData('TabName') === "PaintTray")
                    {
                        this.playSound('place_item');
                        this.MouseDown = true;
                    }
                }
   
            });

            this.input.on('pointerup',()=>
            {
                if (this.MouseDown)
                {
                    this.playSound('place_item');
                    this.MouseDown = false;
                    if(this.LogDraw)
                    {
                        this.LogDraw = false;
                        this.SetItemData.CreateBackLog("Draw", this.DrawLog);
                    }
                }  
            });

            this.input.on('pointermove',(pointer)=>
            {
                if (this.Active.getData('TabName') === "PaintTray" && this.MouseDown)
                {
                    this.LogDraw = true;
                    this.DrawLog = this.PlaceTools.DrawWithShape(pointer,this.RenderLog[this.RenderLog.length-1], this.Circle);
                }
            });

            this.events.on('resume',(sys,Data)=>
            {
                if (Data.Action != "null")
                {
                    if(Data.Action === "New")
                    {
                        this.TweenBackToColorPicker();
                    }
                    else
                    {
                        this.TweensBeforePrintSave(Data);
                    }
                }
            });

            this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.events.off('resume'));
        }

    PlaceAssets()
        {
            let rect = new Phaser.Geom.Rectangle(0, -75, this.mid.x*2, this.mid.y*2+75);
            this.Shader = this.add.graphics({ fillStyle: { color: 0xFFFFFF } });
            this.Shader.fillRectShape(rect);
            this.Shader.setDepth(this.DepthList.Shader);
            this.Shader.alpha = 0;

            const Back = this.addImage(0,0,"Bckg_1");
            Back.setOrigin(0,0);
            Back.setDepth(this.DepthList.BackGround);

            const Table = this.addImage(0,768,"UI _ General/Countertop");
            Table.setOrigin(0,1);
            Table.setDepth(this.DepthList.Table);

            this.PrintPlate = this.addImage(682.5, 618, "UI _ General/Plate");
            this.PrintPlate.setDepth(this.DepthList.Buttons);
            this.PrintPlate.setVisible(false);

            this.Plate = this.addImage(682.5, 630, "UI _ General/Asset 184");
            this.Plate.setDepth(this.DepthList.Buttons);

            this.Cake = this.addImage(682.5, 474, "UI _ General/MCake");
            this.ConstraintObjects.Cake = this.Cake;
            this.Cake.setTint(gameData.CakeColor);
            this.Cake.setDepth(this.DepthList.Tray);

            // const Balloon1 = this.addImage(304, 380, "Title Screen/Blln_3").setDepth(this.DepthList.BalloonBack);
            // const Balloon2 = this.addImage(303, 464, "Title Screen/Blln_4").setDepth(this.DepthList.BalloonFront);
            // const Balloon3 = this.addImage(1030, 496, "Title Screen/Blln_1").setDepth(this.DepthList.BalloonBack);
            // const Balloon4 = this.addImage(1068, 388, "Title Screen/Blln_2").setDepth(this.DepthList.BalloonFront);

            this.CakeGroup.addMultiple([this.Cake,this.PrintPlate,this.Plate]);

            const DoneButton = this.add.container(935,728).setDepth(this.DepthList.Buttons+1);
            const DoneBackGround = this.addImage(0,0, "Btn_Done").setInteractive();
            const DoneText = ABCyaPhaser.Text.addText(20, -2, 36, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('done'), this);

            DoneText.setShadow(-2, 0, '#f58820', 0, true, true);

            DoneButton.add([DoneBackGround, DoneText]);
            
            const RestartButton = this.addImage(985,40, "Menus_Popups/Btn_Start_Over").setInteractive();
            const UndoButton = this.addImage(985,115, "Menus_Popups/Btn_Undo").setInteractive();
            this.SoundOn = this.addImage(985,190, "Menus_Popups/Btn_SoundOff").setInteractive();
            this.SoundOff = this.addImage(985,190, "Menus_Popups/Btn_SoundOn").setInteractive();
            this.SoundOff.setVisible(false);
            this.SoundOn.setVisible(false);
            this.SoundOff.on('pointerdown',()=>this.MuteButton());
            this.SoundOn.on('pointerdown',()=>this.MuteButton());

            this.SoundButton = this.sound.mute ? this.SoundOn : this.SoundOff;
            this.SoundButton.setVisible(true);

            this.Buttons = [RestartButton,UndoButton,this.SoundOn,DoneButton,this.SoundOff];

            RestartButton.setDepth(this.DepthList.Buttons); 
            UndoButton.setDepth(this.DepthList.Buttons); 
            this.SoundButton.setDepth(this.DepthList.Buttons);

            DoneBackGround.on('pointerdown',()=>{
                this.playSound('button_menu_click');
                this.scene.pause();
                this.scene.launch('PausePopUp');
            });

            RestartButton.on('pointerdown',()=>{
                this.playSound('button_menu_click');
                this.scene.pause();
                this.scene.launch('RestartPopUp');
            });

            UndoButton.on('pointerdown',()=>{
                this.SetItemData.BackButton();
            });

            // this.SoundButton.on('pointerdown',()=>{
                
            // });

            this.ConstraintObjects.Restart = RestartButton;
            this.ConstraintObjects.Undo = UndoButton;
            this.ConstraintObjects.Sound = this.SoundButton;
            this.ConstraintObjects.Done = DoneButton;

            //console.log(this.ConstraintObjects);

            this.TabBack = this.addImage(0,768, "UI _ General/Tab_Pullout").setOrigin(0,1);
            this.ConstraintObjects.Tray = this.TabBack;
            this.TabBack.setDepth(this.DepthList.Tray);

            this.TabList[0] = this.addImage(0,97, "UI _ General/Tab_Paint").setData('TabName',"PaintTray");
            this.TabList[1] = this.addImage(-30, (96*2), "UI _ General/Tab_Icing").setData('TabName',"IcingTray");
            this.TabList[2] = this.addImage(-31, (96*3) - 1, "UI _ General/Tab_Pattern").setData('TabName',"PatternTray");
            this.TabList[3] = this.addImage(-30, (96*4) - 3, "UI _ General/Tab_Decor").setData('TabName',"DecorTray");
            this.TabList[4] = this.addImage(-30, (96*5) - 4, "UI _ General/Tab_Flower").setData('TabName',"FlowerTray");
            this.TabList[5] = this.addImage(-30, (96*6) - 5, "UI _ General/Tab_Candle").setData('TabName',"CandleTray");
            this.TabList[6] = this.addImage(-30, (96*7) - 5, "UI _ General/Tab_Numbers").setData('TabName',"NumbersTray");
            this.TabList[7] = this.addImage(-30, (96*8) - 5, "UI _ General/Tab_Letters").setData('TabName',"LettersTray");

            this.Animations.TweenInTray(this.TabList, this.TabBack);
            this.Animations.TweenInCake(this.Cake, this.Plate);
            this.Animations.TweenInButtons(this.Buttons, 400);

            this.Active = this.TabList[0];

            for(let x in this.TabList) //Set Tab Location
                {
                    this.TabList[x].setInteractive();
                    this.TabList[x].setOrigin(0,1);
                    this.TabList[x].setDepth(this.DepthList.Tabs);
                    this.TabList[x].name = x;
                    this.TabList[x].on('pointerdown',function(){
                        //console.log(this.name);
                        //this.scene.Active = this;
                        this.scene.TabClickHandler(this.name);
                    });
                }
        }

    CreateMask()
        {
            //var Graphic = this.add.graphics({ lineStyle: {color: 0x00aaaa } });
            var Shape = this.make.graphics();

            Shape.fillStyle(0xffffff);
            Shape.beginPath();
            //Shape.fillRect(this.mid.x,this.mid.y,400,600);
            this.CandleArea = new Phaser.Geom.Ellipse(this.Cake.x, this.Cake.y-134, 485, 122);
            this.CakeCenter = new Phaser.Geom.Ellipse(this.Cake.x, this.Cake.y+135, 486, 122);
            this.CakeBottom = new Phaser.Geom.Rectangle(this.Cake.x-(this.Cake.width/2), this.Cake.y-134, 483, 268);
            Shape.fillEllipseShape(this.CandleArea);

            //Graphic.fillEllipseShape(EllipseBottom);
            //Graphic.fillEllipseShape(this.CandleArea);
            //Graphic.fillRectShape(RectCenter);

            Shape.fillEllipseShape(this.CakeCenter);
            Shape.fillRectShape(this.CakeBottom);;

            this.CakeMask = Shape.createGeometryMask();
            //console.log(this.CakeMask);
            //this.CakeMask.geometryMask.x = -10;
        }

    MuteButton()
        {
            let Fliped = !this.sound.mute;
            this.sound.setMute(Fliped);
            this.SoundButton.setVisible(false);
            this.SoundButton = Fliped ? this.SoundOn : this.SoundOff;
            this.SoundButton.setVisible(true);
        }

    TabClickHandler(TabNumber)//Should tween the tabs
        {

            if (this.Active.name != TabNumber && this.IsPaused === false)
            {
                //console.log(this.ClearGroup);
                //this.ClearGroup.clear(true,true);

                for (let x in this.TabList)
                {
                    this.TabList[x].disableInteractive();
                }

                this.Animations.TweenOutTab(this.Active, this.ClearGroup, this.TabBack);

                this.Active = this.TabList[TabNumber];
                //console.log(TabNumber);
                this.addDelay(600,()=>{
                    switch(TabNumber)
                    {
                        case "0":
                            this.ClearGroup.addMultiple(this.TrayEntry.PaintEntry());
                            //this.ToolBackgroundTweenIn(this.PaintGroup,this.Active.name);
                            break;
                        case "1":
                            this.ClearGroup.addMultiple(this.TrayEntry.IcingEntry());
                            //this.ToolBackgroundTweenIn(this.IcingGroup,this.Active.name);
                            break;
                        case "2":
                            this.ClearGroup.addMultiple(this.TrayEntry.PatternEntry());
                            //this.ToolBackgroundTweenIn(this.PatternGroup,this.Active.name);
                            break;
                        case "3":
                            this.ClearGroup.addMultiple(this.TrayEntry.DecorEntry());
                            //this.ToolBackgroundTweenIn(this.DecorGroup,this.Active.name);
                            break;
                        case "4":
                            this.ClearGroup.addMultiple(this.TrayEntry.FlowerEntry());
                            //this.ToolBackgroundTweenIn(this.FlowerGroup,this.Active.name);
                            break;
                        case "5":
                            this.ClearGroup.addMultiple(this.TrayEntry.CandleEntry());
                            //this.ToolBackgroundTweenIn(this.CandleGroup,this.Active.name);
                            break;
                        case "6":
                            this.ClearGroup.addMultiple(this.TrayEntry.NumbersEntry());
                            //this.ToolBackgroundTweenIn(this.NumbersGroup,this.Active.name);
                            break;
                        case "7":
                            this.ClearGroup.addMultiple(this.TrayEntry.LettersEntry());
                        default:
                            break;
                    }
                    this.Animations.TweenInTab(this.Active, this.ClearGroup, this.TabBack);
                    this.ClearGroup.getChildren().forEach((child)=>{child.setDepth(this.DepthList.PaintTool);});
                    this.addDelay(492,()=>
                    {
                        for (let x in this.TabList)
                        {
                            this.TabList[x].setInteractive();
                        }
                    });
                    //this.TabList[TabNumber].x = 0;
                });
            }
        }

    SetBrushTint(Number,ButtonPassed)
        {
            var TintList =
                    [
                        0xfedc4b,//18 1
                        0xf9af1e,//19 2
                        0xff8c3d,//20 3
                        0xef4f3b,//17 4
                        0xc32139,//16 5
                        0xff97d0,//15 6
                        0xff5cae,//14 7
                        0xdd67f9,//13 8
                        0xa554f7,//12 9
                        0x5f40d3,//11 10
                        0x5e9afc,//6 11
                        0x62d5ef,//10 12
                        0x68f2ee,//9 13
                        0x5ce0be,//8 14
                        0x88d159,//7 15
                        0xfaf9eb,//1 16
                        0xfcb984,//5 17
                        0xca6c15,//4 18
                        0x7c3f09,//3 19
                        0x424242,//2 20   
                    ];

            this.addTween(this.PressedDrawButton, 100, {scale: .75},Phaser.Math.Easing.Quadratic.InOut);
            this.PressedDrawButton = ButtonPassed;
            this.Circle.fillColor = TintList[Number-1];
            this.PressedSizeButton.setTint(TintList[Number-1]);
            //console.log(Number);
        }

    CircleSize(SelectedSize)
        {
            this.PressedSizeButton.clearTint();
            this.PressedSizeButton = SelectedSize;
            this.PressedSizeButton.setTint(this.Circle.fillColor);
            this.Circle.radius = (this.PressedSizeButton.width/2);
        }

    CreateRenderLayer()
        {
            const Key = (this.RenderLog.length);
            if (Key >= 0)
            {
                this.RenderLog[Key] = this.add.renderTexture(this.Cake.getBottomLeft().x, this.Cake.getTopRight().y, 484, 390);
                this.RenderLog[Key].setMask(this.CakeMask);
                this.RenderLog[Key].setDepth(this.DepthList.PaintTool);
                this.CakeGroup.add(this.RenderLog[Key]);
            }
            else
            {
                this.RenderLog[0] = this.add.renderTexture(this.Cake.getBottomLeft().x, this.Cake.getTopRight().y, 484, 390);
                this.RenderLog[0].setMask(this.CakeMask);
                this.RenderLog[0].setDepth(this.DepthList.PaintTool);
                this.CakeGroup.add(this.RenderLog[0]);
            }
        }

    BackFromPrintSave()
        {
            const Timer = this.Animations.PrintResizeOut(this.Top,this.OverImage,this.Bottom);
                    Timer.on('complete',()=>
                    {
                        this.playSound('drawer_open_close');
                        this.PrintPlate.setVisible(false);
                        this.Plate.setVisible(true);
                        this.Shader.setDepth(this.DepthList.Shader);
                        this.Animations.TweenOutButtons(this.Buttons, 400,Phaser.Math.Easing.Linear,false);
                        this.Animations.TweenInTrayPrint(this.TabList, this.ClearGroup, this.TabBack);
                        this.Animations.TweenInForPrintSave(this.CakeGroup,this.Shader);
                    });
        }

    TweenBackToColorPicker()
        {
            this.playSound('drawer_open_close');
            this.Animations.TweenOutButtons(this.Buttons, 400);
            this.Animations.TweenOutTrayPrint(this.TabList, this.ClearGroup, this.TabBack);
            let Timer = this.Animations.TweenToCakeColorScreen(this.CakeGroup);
            this.playSound("plate_tween");

            Timer.once('complete',()=>{this.scene.start("PickCakeColor");});
        }

    TweensBeforePrintSave(Data)
        {
            this.PrintPlate.setVisible(true);
            this.Plate.setVisible(false);
            //this.Animations.TweenOutButtons(this.Buttons, 400,Phaser.Math.Easing.Linear,false);
            this.playSound('drawer_open_close');
            this.Animations.TweenOutButtons(this.Buttons, 400);
            let Tween = this.Animations.TweenOutTrayPrint(this.TabList, this.ClearGroup, this.TabBack);
            this.Animations.TweenOutForPrintSave(this.CakeGroup,this.Shader);

            Tween.on('complete',()=>{this.ScaleDownForPrintSave(Data);})
        }

    ScaleDownForPrintSave(Data)
        {
            this.game.renderer.snapshotArea(0, 0, this.game.canvas.width, this.game.canvas.height, (image)=>{
                if (this.textures.exists('snap'))
                {
                    this.textures.remove('snap');
                    this.textures.removeKey('snap');
                }
                this.textures.addBase64('snap',image.src);
                this.textures.once('addtexture',()=>
                {
                    this.Shader.setDepth(this.DepthList.Tabs);
                    this.OverImage = this.add.image(this.mid.x,this.mid.y,'snap');
                    // this.Top = this.addImage(this.mid.x,108, "Text_Name_Bday").setDepth(this.DepthList.Tabs);
                    this.Top = this.add.container().setDepth(this.DepthList.Tabs); 
                    const name = ABCyaPhaser.Text.addText(170,108, 24, 0x000000, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('name_birthday_line'), this.Top).setOrigin(0,.5);
                    const date = ABCyaPhaser.Text.addText(854,108, 24, 0x000000, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('birthday_line'), this.Top).setOrigin(1, 0.5);
                    
                    const underscoreSpace = 854 - 170 - date.width - 5; // end point of print window - start point of print area - date.width - buffer space

                    do{
                      name.text += "_";
                    } while(name.width < underscoreSpace)

                    this.Bottom = ABCyaPhaser.Images.addImage(this.mid.x,749, 'Text_ABCya', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setDepth(this.DepthList.Tabs);
                    this.OverImage.setDepth(this.DepthList.Tabs);
                    const Timer = this.Animations.PrintResizeIn(this.Top,this.OverImage,this.Bottom);
                    Timer.on('complete',()=>SavePrintCake(Data,this));
                });
            });
        }

    update()
        {
            this.PlaceTools.InUpdate(this.input.activePointer);
        }

}